import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "src/app/Services/auth/auth.service";
import { CommonModule } from "@angular/common";
import { IonRippleEffect, Platform } from "@ionic/angular/standalone";
import { TranslateModule } from "@ngx-translate/core";
import { Keyboard } from "@capacitor/keyboard";
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: true,
  imports: [RouterModule, CommonModule, IonRippleEffect, TranslateModule],
})
export class NavbarComponent implements OnInit {
  currentRoute: string = "";
  currentRole: string | null = "";
  isKeyboardOpen: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private platform: Platform
  ) {
    if (this.platform.is("capacitor")) {
      Keyboard.addListener("keyboardWillShow", () => {
        this.isKeyboardOpen = true;
      });

      Keyboard.addListener("keyboardWillHide", () => {
        this.isKeyboardOpen = false;
      });
    }
  }

  ngOnInit() {
    this.currentRole = this.authService.getCurrentRole();

    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  isRouteActive(route: string): boolean {
    return this.currentRoute === route;
  }
}
